var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataList',{attrs:{"resource":"users","headers":_vm.headers,"title":"Список пользователей","disable-adding":"","store":"users","disable-compact-mode":"","disable-sort":"","disable-filter":""}})}
var staticRenderFns = []

export { render, staticRenderFns }